module.exports = __webpack_public_path__ + "static/media/sun-small-cloud.c0142ee6.png";